import React from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import FicheActeur from "../components/FicheActeur";

const Acteur = () => {
    return (
        <div>
            <Navigation />
            <FicheActeur />
            <Footer />
        </div>
    )
}


export default Acteur;